import { TeamPermission, TeamPermissionCategory } from './enums'

export const teamPermissionTextMap: Record<TeamPermission, string> = {
  [TeamPermission.DocumentsEdit]: 'Edit documents',
  [TeamPermission.DocumentsView]: 'View documents',
  [TeamPermission.DocumentsInternal]: 'Internal documents access',

  [TeamPermission.FeatureFlagsEdit]: 'Edit feature flags',
  [TeamPermission.FeatureFlagsView]: 'View feature flags',
  [TeamPermission.FeatureFlagsDelete]: 'Delete feature flags',
  [TeamPermission.FeatureFlagsCreate]: 'Create feature flags',

  [TeamPermission.MarketEdit]: 'Edit market data',
  [TeamPermission.MarketView]: 'View market data',
  [TeamPermission.MarketDelete]: 'Delete market entries',
  [TeamPermission.MarketCreate]: 'Create market entries',

  [TeamPermission.OnboardingEdit]: 'Edit onboarding process',
  [TeamPermission.OnboardingView]: 'View onboarding details',
  [TeamPermission.OnboardingCreate]: 'Create onboarding entries',
  [TeamPermission.OnboardingRecollect]: 'Recollect onboarding data',
  [TeamPermission.OnboardingInternal]: 'Internal onboarding access',
  [TeamPermission.OnboardingDownloadCsv]: 'Download onboarding data as CSV',

  [TeamPermission.PartnerEdit]: 'Edit partners',
  [TeamPermission.PartnerView]: 'View partners',
  [TeamPermission.PartnerGigsafeConfigEdit]: 'Edit GigSafe config',
  [TeamPermission.PartnerGigsafeConfigView]: 'View GigSafe config',
  [TeamPermission.PartnerProductsEdit]: 'Edit partner products',
  [TeamPermission.PartnerProductsView]: 'View partner products',
  [TeamPermission.PartnerProductsDelete]: 'Delete partner products',
  [TeamPermission.PartnerProductsCreate]: 'Create partner products',

  [TeamPermission.PartnerDriversImport]: 'Import partner drivers',
  [TeamPermission.PartnerDriversEdit]: 'Edit partner driver details',
  [TeamPermission.PartnerDriversView]: 'View partner driver details',

  [TeamPermission.PaymentsEdit]: 'Edit payments',
  [TeamPermission.PaymentsView]: 'View payments',
  [TeamPermission.PaymentsDelete]: 'Delete payments',
  [TeamPermission.PaymentsCreate]: 'Create payments',
  [TeamPermission.PaymentsProcess]: 'Process payments',
  [TeamPermission.PaymentsDownloadInvoices]: 'Download invoices as CSV',
  [TeamPermission.PaymentsCreateBuyer]: 'Create buyer profile',

  [TeamPermission.TemplatesEdit]: 'Edit templates',
  [TeamPermission.TemplatesView]: 'View templates',
  [TeamPermission.TemplatesDelete]: 'Delete templates',
  [TeamPermission.TemplatesCreate]: 'Create templates',

  [TeamPermission.UsersEdit]: 'Edit users',
  [TeamPermission.UsersView]: 'View users',
  [TeamPermission.UsersCreate]: 'Create users',

  [TeamPermission.LoginAs]: 'Login as another user',

  [TeamPermission.InvitesView]: 'View invites',
  [TeamPermission.InvitesCreate]: 'Create invites',
  [TeamPermission.InvitesEdit]: 'Invites edit',

  [TeamPermission.RolesView]: 'View roles',
  [TeamPermission.RolesEdit]: 'Edit roles',
  [TeamPermission.RolesDelete]: 'Roles delete',

  [TeamPermission.AccessUpdate]: 'Access update',

  [TeamPermission.ContractorView]: 'Contractor view',

  [TeamPermission.CustomerReviewRejectionReasonView]: 'View customer review rejection reasons',
  [TeamPermission.CustomerReviewRejectionReasonEdit]: 'Edit customer review rejection reasons',
  [TeamPermission.CustomerReviewRejectionReasonDelete]: 'Delete customer review rejection reasons',

  [TeamPermission.CustomerMasterContractorView]: 'View customer master contractors',
  [TeamPermission.CustomerMasterContractorEdit]: 'Edit customer master contractors',
  [TeamPermission.CustomerMasterContractorCreate]: 'Create customer master contractors',
  [TeamPermission.CustomerMasterContractorDelete]: 'Delete customer master contractors',

  [TeamPermission.SubcontractorView]: 'View subcontractors',
  [TeamPermission.SubcontractorEdit]: 'Edit subcontractors',
  [TeamPermission.SubcontractorDelete]: 'Delete subcontractors',

  [TeamPermission.MasterContractorCustomerView]: 'View master contractor customers',
  [TeamPermission.MasterContractorCustomerEdit]: 'Edit master contractor customers',
  [TeamPermission.MasterContractorCustomerDelete]: 'Delete master contractor customers',

  [TeamPermission.MasterContractorCustomerSubcontractorView]:
    'View master contractor customer subcontractors',
  [TeamPermission.MasterContractorCustomerSubcontractorEdit]:
    'Edit master contractor customer subcontractors',
  [TeamPermission.MasterContractorCustomerSubcontractorDelete]:
    'Delete master contractor customer subcontractors',

  [TeamPermission.McLiteView]: 'View McLite records',
  [TeamPermission.McLiteEdit]: 'Edit McLite records',
  [TeamPermission.McLiteDelete]: 'Delete McLite records',

  [TeamPermission.PersonallyIdentifiableInformationView]:
    'View personally identifiable information (PII)',

  [TeamPermission.ContractorNotesView]: 'View contractor notes',
  [TeamPermission.ContractorNotesCreate]: 'Create contractor notes',
  [TeamPermission.ContractorNotesEdit]: 'Edit contractor notes',

  [TeamPermission.ContractorFilesView]: 'View contractor files',
  [TeamPermission.ContractorFilesCreate]: 'Create contractor files',
  [TeamPermission.ContractorFilesEdit]: 'Edit contractor files',
  [TeamPermission.ContractorFilesDelete]: 'Delete contractor files',
}

export const teamPermissionCategoryTextMap: Record<TeamPermissionCategory, string> = {
  [TeamPermissionCategory.Documents]: 'Documents',
  [TeamPermissionCategory.Market]: 'Market',
  [TeamPermissionCategory.Onboarding]: 'Onboarding',
  [TeamPermissionCategory.PartnerDrivers]: 'Partner Drivers',
  [TeamPermissionCategory.Payments]: 'Payments',
  [TeamPermissionCategory.Templates]: 'Templates',
  [TeamPermissionCategory.Users]: 'Users',
  [TeamPermissionCategory.FeatureFlags]: 'Feature Flags',
  [TeamPermissionCategory.Partner]: 'Partner',
  [TeamPermissionCategory.Role]: 'Role',
  [TeamPermissionCategory.CustomerReviewRejectionReason]: 'Customer Review Rejection Reason',
  [TeamPermissionCategory.CustomerMasterContractor]: 'Customer Master Contractor',
  [TeamPermissionCategory.Subcontractor]: 'Subcontractor',
  [TeamPermissionCategory.MasterContractorCustomer]: 'Master Contractor Customer',
  [TeamPermissionCategory.MasterContractorCustomerSubcontractor]:
    'Master Contractor Customer Subcontractor',
  [TeamPermissionCategory.McLite]: 'McLite',
  [TeamPermissionCategory.PersonallyIdentifiableInformation]: 'Personally Identifiable Information',
  [TeamPermissionCategory.ContractorFiles]: 'Contractor Files',
  [TeamPermissionCategory.ContractorNotes]: 'Contractor Notes',
}
